<template>
    <v-card class="rounded-lg">
        <v-card-title>
            Reports
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
            
            <v-row>
                <v-col cols="12" sm="5" class="pa-4">
                <v-menu
                    ref="startMenu"
                    v-model="startMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formattedStartDate"
                        @blur="updateStartDate($event.target.value)"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="start_date"
                    no-title
                    @input="date => { startMenu = false; start_date = date }"
                    ></v-date-picker>
                </v-menu>
                </v-col>

                <v-col cols="12" sm="5" class="pa-4">
                <v-menu
                    ref="endMenu"
                    v-model="endMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="formattedEndDate"
                        @blur="updateEndDate($event.target.value)"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="end_date"
                    no-title
                    @input="date => { endMenu = false; end_date = date }"
                    ></v-date-picker>
                </v-menu>
                </v-col>
                <v-col cols="12" sm="2" class="px-4 pt-8 pb-4">
                    <v-btn @click="loadRecordings()" color="primary" :loading="loading">Go</v-btn>
                </v-col>
            </v-row>

            <v-card-subtitle v-if="users.length > 0">Total Duration: {{ totalDuration }} ({{ formatToDollars(totalDuration/60*0.0135) }}) <small>*dollar amounts are estimates</small></v-card-subtitle>

            <v-data-table v-if="users.length" :loading="loading"
                :headers="headers"
                :items="users"
                :items-per-page="50"
                class="elevation-1"            
            >
                <template v-slot:item.average_duration="{ item }">
                    {{formatDuration(item.average_duration)}} ({{ formatToDollars(item.average_duration/60*0.0135) }})
                </template>
                <template v-slot:item.total_duration="{ item }">
                    {{formatDuration(item.total_duration)}} ({{ formatToDollars(item.total_duration/60*0.0135) }})
                </template>
            </v-data-table>
            <div v-else class="text-h5 text--disabled text-center">No Recordings</div>
        </v-card-text>
    </v-card>
</template>

<script>
import { useUserStore } from '../../stores/user'

export default {
    name: 'Reports',
    created: function() {
        // this.app = useAppStore()
        this.user = useUserStore()
    },
    data: function() {
        return {
            app: null,
            user: null,
            recordings: [],
            users: [],
            start_date: null,
            end_date: null,
            startMenu: false,
            endMenu: false,
            headers: [
                { text: 'User', value: 'userlogin' },
                { text: 'Total Recordings', value: 'total_recordings' },
                { text: 'Average Duration', value: 'average_duration' },
                { text: 'Total Duration', value: 'total_duration' },
            ],
            loading: false,
        }
    },
    mounted: function() {
        this.loadRecordings()
    },
    computed: {
        formattedStartDate() {
            return this.start_date ? moment(this.start_date).format('MMM D, YYYY') : '';
        },
        formattedEndDate() {
            return this.end_date ? moment(this.end_date).format('MMM D, YYYY') : '';
        },
        totalDuration() {
            let duration = 0
            this.users.forEach(user => {
                if(user.total_duration)
                    duration += user.total_duration
            })
            return duration.toFixed(1)
        }
    },
    methods: {
        loadRecordings: function() {
            this.loading = true

            if(this.start_date == null)
                this.start_date = moment().subtract(30, 'days').format('YYYY-MM-DD')
            if(this.end_date == null)
                this.end_date = moment().format('YYYY-MM-DD')

            this.user.app.get(`meeting/recordings_report?start_date=${this.start_date}&end_date=${this.end_date}`).then(response => {
                // this.recordings = response.data.recordings
                this.users = response.data.users
                this.loading = false
                this.processData()
            })
            .catch(error => {
                console.error(error)
                this.loading = false
            })
        },
        formatRecordingDate: function(recording) {
            let data = JSON.parse(recording.post_content)
            const localDate = moment(data.timestamp).local();
            const formattedDate = localDate.format('MMM D, YYYY h:mmA'); // "Nov 22, 2023 5:32PM"
            return formattedDate
        },
        processData: function() {
            console.log("processData")
            // this.recordings.forEach(recording => {
            //     if(!this.users[recording.post_author])
            //         this.users[recording.post_author] = []
            //     let recording_id = String(recording.ID)
                
            //     this.users[recording.post_author].push([`recording_id`: recording])
            // })
        },
        updateStartDate(dateStr) {
            // Assuming dateStr is in the format "MMM D, YYYY"
            // and you want to convert it back to "YYYY-MM-DD".
            const parsedDate = moment(dateStr, 'MMM D, YYYY');
            if (parsedDate.isValid()) {
               this.start_date = parsedDate.format('YYYY-MM-DD');
            } else {
                console.error('Invalid date format');
                // Handle invalid date format (e.g., show an error message)
            }
        },
        updateEndDate(dateStr) {
            // Assuming dateStr is in the format "MMM D, YYYY"
            // and you want to convert it back to "YYYY-MM-DD".
            const parsedDate = moment(dateStr, 'MMM D, YYYY');
            if (parsedDate.isValid()) {
               this.end_date = parsedDate.format('YYYY-MM-DD');
            } else {
                console.error('Invalid date format');
                // Handle invalid date format (e.g., show an error message)
            }
        },
        formatDuration(seconds) {
            // Create a moment duration object from the seconds
            let duration = moment.duration(seconds, 'seconds');
            
            // Format it as "hours:minutes:seconds"
            let formatted = Math.floor(duration.asHours()) + moment.utc(duration.asMilliseconds()).format(":mm:ss");
            
            return formatted;
        },
        formatToDollars(number) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(number);
        }
        // loadProducts: function() {
        //     this.user.app.get('account/products')
        // }

    }
}
</script>
